export const standardMaterialsOptions = [
    {
        label: 'mapa topograficzna w skali 1:10 000, PL-UTM',
        value: 'mapa topograficzna w skali 1:10 000, PL-UTM',
        state: 'selectedMaterialName',
        category: 2,
    },
];
  
export const kartoMaterialsOptions = [
    {
        label: 'mapa glebowo-rolnicza w skali 1:5 000',
        value: 'mapa glebowo-rolnicza w skali 1:5 000',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa glebowo-rolnicza w skali 1:5 000, PL-1992',
        value: 'mapa glebowo-rolnicza w skali 1:5 000, PL-1992',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa glebowo-rolnicza w skali 1:5 000, 2000',
        value: 'mapa glebowo-rolnicza w skali 1:5 000, 2000',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa glebowo-rolnicza w skali 1:5 000, PL-1992, obrębowa',
        value: 'mapa glebowo-rolnicza w skali 1:5 000, PL-1992, obrębowa',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa glebowo-rolnicza w skali 1:5 000, 2000, obrębowa',
        value: 'mapa glebowo-rolnicza w skali 1:5 000, 2000, obrębowa',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa glebowo-rolnicza w skali 1:25 000',
        value: 'mapa glebowo-rolnicza w skali 1:25 000',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa glebowo-rolnicza w skali 1:100 000',
        value: 'mapa glebowo-rolnicza w skali 1:100 000',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa sozologiczna, PL-1942',
        value: 'mapa sozologiczna, PL-1942',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa sozologiczna, PL-1992',
        value: 'mapa sozologiczna, PL-1992',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa hydrograficzna, PL-1942',
        value: 'mapa hydrograficzna, PL-1942',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa hydrograficzna, 1965',
        value: 'mapa hydrograficzna, 1965',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa hydrograficzna, PL-1992',
        value: 'mapa hydrograficzna, PL-1992',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'mapa hydrograficzna, PL-1992, 2016',
        value: 'mapa hydrograficzna, PL-1992, 2016',
        state: 'selectedMaterialName',
        category: 1,
    },
];
  
export const customMaterialsOptions = [
    {
        label: 'w skali 1:10 000, PL-1942',
        value: 'Niestandardowe opracowania topograficzne w skali 1:10 000, PL-1942',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:10 000, PL-1992',
        value: 'Niestandardowe opracowania topograficzne w skali 1:10 000, PL-1992',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:10 000, 1965',
        value: 'Niestandardowe opracowania topograficzne w skali 1:10 000, 1965',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:25 000, PL-1942',
        value: 'Niestandardowe opracowania topograficzne w skali 1:25 000, PL-1942',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:25 000, 1965',
        value: 'Niestandardowe opracowania topograficzne w skali 1:25 000, 1965',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:50 000, 1965',
        value: 'Niestandardowe opracowania topograficzne w skali 1:50 000, 1965',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:50 000, PL-1942',
        value: 'Niestandardowe opracowania topograficzne w skali 1:50 000, PL-1942',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:50 000, PL-1992',
        value: 'Niestandardowe opracowania topograficzne w skali 1:50 000, PL-1992',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:50 000, PL-UTM',
        value: 'Niestandardowe opracowania topograficzne w skali 1:50 000, PL-UTM',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:100 000, PL-1942',
        value: 'Niestandardowe opracowania topograficzne w skali 1:100 000, PL-1942',
        state: 'selectedMaterialName',
        category: 1,
    },
    {
        label: 'w skali 1:100 000, GUGiK80',
        value: 'Niestandardowe opracowania topograficzne w skali 1:100 000, GUGiK80',
        state: 'selectedMaterialName',
        category: 1,
    },
];
  
export const categoriesDict = {
    1: 'Kartograficzne opracowania tematyczne oraz niestandardowe opracowania topograficzne niewymienione w tabelach nr 1–13',
    2: 'Standardowe opracowanie kartograficzne 1:10 000',
    3: 'Niestandardowe opracowanie tematyczne - inne',
    4: 'Kartograficzne opracowanie tematyczne - inne',
    5: 'Inne materiały - inne niewymienione',
};




// WEBPACK FOOTER //
// src/routes/eservices/dicts.js